export default function ContractTable({
  contracts,
  onView,
  onEdit,
  onAssign,
  onHistory,
}) {
  const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);

    const pad = (n) => String(n).padStart(2, "0");

    const formatted =
      `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

    return formatted;
  };
  return (
    <div className="bg-white rounded-xl shadow p-4">
      <table className="w-full text-sm">
        <thead className="text-gray-500 border-b">
          <tr>
            <th className="text-left p-2">Contract</th>
            <th className="text-left p-2">Status</th>
            <th className="text-left p-2">Updated</th>
            <th className="text-right p-2">Actions</th>
          </tr>
        </thead>

        <tbody>
          {contracts.length === 0 ? (
            <tr>
              <td className="p-2 text-gray-500 text-center" colSpan="4">
                No contracts available.
              </td>
            </tr>
          ) : (
            contracts.map((c) => (
              <tr key={c.id} className="border-b hover:bg-gray-50">
                <td className="p-2 font-medium">{c.title}</td>

                <td className="px-3 py-2">
                  <span
                    className={`
      inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold capitalize
      transition-all
      ${
        c.status === "draft"
          ? "bg-gray-100 text-gray-700 border border-gray-200"
          : ( c.status === "pending" || c.status === "sent")
            ? "bg-amber-100 text-amber-700 border border-amber-200"
            : ( c.status === "approved" || c.status === "signed" || c.status === "completed")
              ? "bg-green-100 text-green-700 border border-green-200"
              : "bg-slate-100 text-slate-600 border border-slate-200"
      }
    `}
                  >
                    <span
                      className={`
        w-1.5 h-1.5 rounded-full mr-2
        ${
          c.status === "draft"
            ? "bg-gray-500"
            : ( c.status === "pending" || c.status === "sent")
              ? "bg-amber-500"
              :( c.status === "approved" || c.status === "signed" || c.status === "completed")
                ? "bg-green-500"
                : "bg-slate-400"
        }
      `}
                    />
                    {c.status}
                  </span>
                </td>
                <td className="text-gray-500">
                  {formatDateTime(c.updated_at)}
                </td>

                <td className="text-right space-x-2">
                  <button onClick={() => onView(c)}>View Details</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}